export default __webpack_public_path__ + "static/media/blue-check.66a79b2d.svg";